"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultistreamState = void 0;
const tslib_1 = require("tslib");
const ui_state_1 = tslib_1.__importDefault(require("./ui-state"));
exports.MultistreamState = ui_state_1.default;
//# sourceMappingURL=index.js.map